import { useMemo } from 'react';
import useContentSuggestions from './useContentSuggestions';
import filterContentSuggestions from './filterContentSuggestions';

export const useFilteredContentSuggestions = (searchString: string) => {
  const suggestions = useContentSuggestions();

  return useMemo(
    () => filterContentSuggestions(suggestions, searchString),
    [suggestions, searchString],
  );
};

export default useFilteredContentSuggestions;
